export default [
	{
		path: "/admin/licensing",
		exact: true,
		policy: "superAdminAuth",
		component: "Licensing",
		mui: true,
	},
];
